import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
interface ItemType {
    img: [string, string];
    name: string;
    text: string;
}

const I: React.FC = () => {
    const { t } = useLang('d3u');
    const imgs: [string, string] = [
        'https://websiteoss.ecoflow.com/upload/image/1768528231491/pc%20(1).jpg',
        'https://websiteoss.ecoflow.com/upload/image/1768528230946/m.jpg',
    ];
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1768528231869/%E5%9B%BE%E7%89%87.jpg', 'https://websiteoss.ecoflow.com/upload/image/1768528230581/mm.jpg'],
            name: t('I_item1_name'),
            text: t('I_item1_text'),

        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1768528230446/%E5%9B%BE%E7%89%87%20(1).jpg', 'https://websiteoss.ecoflow.com/upload/image/1768528231703/Frame%202094654545.jpg'],
            name: t('I_item2_name'),
            text: t('I_item2_text'),

        },
    ];
    return (
        <section className={`${css.section} D3U-I GtmModuleData-section`} id="D3U-I" data-section-id={'D3U-I'} data-section-id2={t('I_title')}>
            <div className="info">
                <div className="label">{t('I_label')}</div>
                <div className="title">{t.rich('I_title', {
                    t: (t: string) => <span>{t}</span>
                })}</div>
            </div>
            <div className="img">
                <EcoImg pc={imgs[0]} pad={imgs[0]} h5={imgs[1]} />
            </div>
            <div className="tip-title">{t('I_name')}</div>
            <div className="tip">{t('I_tip')}</div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className="item" key={k}>
                        <div className="img">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="tip2">{t('I_footer')}</div>
        </section>
    );
};

export default I;
